import styled from 'styled-components';

export const FunnelChartWidgetStyled = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
`;
